import { useContext, useEffect, useState } from "react";
import ProceedingsInProgress from "./ProceedingsInProgress";
import ProceedingMessages from "./ProceedingMessages";
import ContractMessages from "./ContractMessages";
import InterestMessages from "./InterestMessages";
import CurrentUserContext from "../CurrentUserContext";
import {
  canRoleViewBalanceMessages,
  canRoleViewContractMessages,
  canRoleViewProceedingsInProgress,
  canRoleViewProceedingMessages,
  canRoleViewRobotMessages,
  canRoleViewRealEstateComplexMessages,
} from "../util/rightsManagers/homepage/viewRightsManager";
import AssetAccountingMessages from "./AssetAccountingMessages";
import { MessageBlock, Section } from "mta-rkvr-styles";
import { Alert, AlertsResponseBody } from "../types/admin/Alerts";
import { get } from "../api/fetch";
import RobotMessages from "./RobotMessages";
import RealEstateComplexMessages from "./RealEstateComplexMessages";
import InvestmentProjectMessages from "./InvestmentProjectMessages";
import { useTranslation } from "react-i18next";

const HomePageAuth = () => {
  const { t } = useTranslation();
  const [alerts, setAlerts] = useState<Alert[]>();

  useEffect(() => {
    get<AlertsResponseBody>({
      endPoint: "alerts",
      queryParams: [{ name: "showActive", value: "true" }],
    }).then((res) => res.ok && setAlerts(res.body.resultsList));
  }, []);

  const { usageRights } = useContext(CurrentUserContext);
  return (
    <>
      {alerts?.map((alert) => (
        <MessageBlock key={alert.alertId} theme="warning" messages={alert.teade ? [alert.teade] : []} />
      ))}
      {canRoleViewProceedingsInProgress(usageRights) && <ProceedingsInProgress />}
      {canRoleViewProceedingMessages(usageRights) && <ProceedingMessages />}
      {canRoleViewBalanceMessages(usageRights) && <AssetAccountingMessages />}
      {canRoleViewContractMessages(usageRights) && <ContractMessages />}
      <Section
        title={t("homePageAuth.interestMessages.title")}
        collapsable={true}
        collapsed={false}
        withCollapseIcon={true}
      >
        <InterestMessages teateType="RVTEADE" />
        <InterestMessages teateType="KOVTEADE" />
      </Section>
      {canRoleViewRobotMessages(usageRights) && <RobotMessages />}
      {canRoleViewRealEstateComplexMessages(usageRights) && <RealEstateComplexMessages />}
      {canRoleViewRealEstateComplexMessages(usageRights) && <InvestmentProjectMessages />}
    </>
  );
};

export default HomePageAuth;
